/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export class PortScannerJob implements Models.IJob {
        public jobId: string;
        public creationDate: Date;
        public jobStatus: string;
        public assignedProbe: Models.IProbe;
        public jobInfo: Models.IJobInfo;
        public jobResult: Models.IJobResult;
        public jobType: string;

        constructor() {
            this.jobId = '';
            this.creationDate = new Date();
            this.jobStatus = '';
            this.assignedProbe = new Models.Probe();
            this.jobInfo = new Models.PortScannerJobInfo();
            this.jobResult = new Models.PortScannerJobResult();
            this.jobType = JobType.PORT_SCANNER;
        }
    }
    
    export class PortScannerJobResult implements IJobResult {
        public data: Object;
        
        constructor() {
            this.data = {};
        }
    }

    export class PortScannerJobRequest implements IJobRequest {
        public probeId: number;
        public jobInfo: IJobInfo;

        constructor() {
            this.probeId = -1;
            this.jobInfo = new PortScannerJobInfo();
        }
    }
    
    export class PortScannerJobInfo implements IJobInfo {
        public networkElementHref: number;
        public networkNode: Models.INetworkNode;
        public networkNodeType: Models.INetworkNodeType;
        public ipAddress: string;
        public ports: number[];
        public portsRaw: string;
        public mappedPortsInfo: string[];
        public mappedPortsRaw: string;
        public protocol: string;
        
        constructor() {
            this.networkElementHref = undefined;
            this.ipAddress = '';
            this.portsRaw = '';
            this.mappedPortsRaw = '';
            this.protocol = '';
        }
    }
}
